<script>
  import bus from '@utils/bus'
  import {get} from '@utils/storage'

  export default {
    data () {
      return {
        form: {},
        cursos: []
      }
    },
    watch: {
      '$route': function () {
        this.buscarDados()
      }
    },
    async mounted () {
      await this.buscarDados()
      bus.$emit('hide-loader')
    },
    methods: {
      async buscarDados () {
        this.cursos = [...await get('opcoes')]
        this.form = {...await get('form')}
      }
    }
  }
</script>
<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex xs12>
                              <h3 class="title my-2">Processo Seletivo</h3>
                            </v-flex>

                            <v-flex xs12 sm4 class="mb-2">
                                <span class="label">{{form.ref_processo_seletivo}}</span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex xs12>
                              <h3 class="title my-2">Local Prova</h3>
                            </v-flex>

                            <v-flex xs12 sm4 class="mb-2">
                                <span class="label">{{form.local_prova}}</span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12>
                            <h3 class="title my-2">Opcões de Cursos</h3>
                        </v-flex >

                        <v-flex xs12 sm4 v-for="curso in cursos" class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <span class="label"><strong>{{curso.opcao}}ª Opção</strong></span>
                                </v-flex>
                                <v-flex xs12>
                                    <span class="label"><strong>Curso:</strong></span>
                                    <span class="dado">{{curso.curso}}</span>
                                </v-flex>
                                <v-flex xs12>
                                    <span class="label"><strong>Campus:</strong></span>
                                    <span class="dado">{{curso.campus}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12>
                            <h3 class="title my-2">Dados Pessoais</h3>
                        </v-flex >

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Nome Completo:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.nome}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>E-mail:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.email}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Telefono:</strong> </span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.telefone}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>CPF:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.cpf}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>RG:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.rg}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Data Nascimento:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.dt_nascimento | dateEnToBr}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Sexo:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.sexo == 'M' ? 'Masculino' : 'Feminino'}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                         <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>ENEM:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.enem}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Ano ENEM:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.ano_enem}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                         <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Treineiro:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.treineiro ? 'Sim' : 'Não'}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs5>
                                    <span class="label"><strong>Possui Necessita Especiais?</strong></span>
                                </v-flex>
                                <v-flex xs7>
                                    <span class="dado">{{form.fl_necessidade_especial ? 'Sim' : 'Não'}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <span class="label"><strong>Necessita de auxílio para realizar a prova?</strong></span>
                                </v-flex>
                                <v-flex xs6>
                                    <span class="dado">{{form.auxilio_prova ? 'Sim' : 'Não'}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                         <v-flex xs12 sm12 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <span class="label"><strong>Podemos usar o Whatsapp, E-Mail e SMS para falar sobre sua inscrição e matricula?</strong></span>
                                </v-flex>
                                <v-flex xs6>
                                    <span class="dado">{{form.fl_receber_contato ? 'Sim' : 'Não'}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-divider ></v-divider>
                        </v-flex>

                        <v-flex xs12>
                            <h3 class="title my-2">Endereço</h3>
                        </v-flex >

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>CEP:</strong> </span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.cep}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Endereço:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.endereco}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Número:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.numero}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Complemento:</strong></span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.complemento}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Cidade:</strong> </span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.cidade}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Bairro:</strong> </span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.bairro}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 class="mb-2">
                            <v-layout row wrap>
                                <v-flex xs3>
                                    <span class="label"><strong>Estado:</strong> </span>
                                </v-flex>
                                <v-flex xs9>
                                    <span class="dado">{{form.estado}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                    </v-layout>
            </v-card>
        </v-flex>

    </v-layout>
</template>
<style lang="scss">
.dado {
    color: #5f6368;
}
</style>



// WEBPACK FOOTER //
// Confirmacao.vue?d2a288c0